import { render, staticRenderFns } from "./NormalCombo.vue?vue&type=template&id=45534176&scoped=true&"
import script from "./NormalCombo.vue?vue&type=script&lang=js&"
export * from "./NormalCombo.vue?vue&type=script&lang=js&"
import style0 from "./NormalCombo.vue?vue&type=style&index=0&id=45534176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45534176",
  null
  
)

export default component.exports